/**
 * Homepage Sport Carousel
 * Lightweight carousel implementation for the homepage sport images
 * Features: Auto-play, smooth fade transitions, click-to-navigate indicators
 */

(function() {
  'use strict';

  // Configuration
  const AUTOPLAY_INTERVAL = 5000; // 5 seconds per slide
  const SLIDE_SELECTOR = '.sport-carousel__slide';
  const INDICATOR_SELECTOR = '.sport-carousel__indicator';
  const ACTIVE_SLIDE_CLASS = 'sport-carousel__slide--active';
  const ACTIVE_INDICATOR_CLASS = 'sport-carousel__indicator--active';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.sport-carousel');

    // Exit if carousel doesn't exist on this page
    if (!carousel) {
      return;
    }

    const slides = carousel.querySelectorAll(SLIDE_SELECTOR);
    const indicators = carousel.querySelectorAll(INDICATOR_SELECTOR);
    let currentSlide = 0;
    let autoplayTimer = null;

    /**
     * Show a specific slide by index
     * @param {number} index - The slide index to show
     */
    function showSlide(index) {
      // Validate index
      if (index < 0 || index >= slides.length) {
        return;
      }

      // Remove active classes from all slides and indicators
      slides.forEach(function(slide) {
        slide.classList.remove(ACTIVE_SLIDE_CLASS);
      });
      indicators.forEach(function(indicator) {
        indicator.classList.remove(ACTIVE_INDICATOR_CLASS);
      });

      // Add active class to current slide and indicator
      slides[index].classList.add(ACTIVE_SLIDE_CLASS);
      indicators[index].classList.add(ACTIVE_INDICATOR_CLASS);

      // Update current slide index
      currentSlide = index;
    }

    /**
     * Show the next slide in the carousel
     */
    function nextSlide() {
      const nextIndex = (currentSlide + 1) % slides.length;
      showSlide(nextIndex);
    }

    /**
     * Start autoplay
     */
    function startAutoplay() {
      stopAutoplay(); // Clear any existing timer
      autoplayTimer = setInterval(nextSlide, AUTOPLAY_INTERVAL);
    }

    /**
     * Stop autoplay
     */
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    /**
     * Restart autoplay after user interaction
     */
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    // Set up click handlers for indicators
    indicators.forEach(function(indicator, index) {
      indicator.addEventListener('click', function() {
        showSlide(index);
        restartAutoplay(); // Restart autoplay after manual navigation
      });
    });

    // Pause autoplay when user hovers over carousel
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Pause autoplay when page is not visible (tab switching)
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    // Initialize: Start autoplay
    startAutoplay();

    // Clean up on page unload
    window.addEventListener('beforeunload', function() {
      stopAutoplay();
    });
  });

})();
